// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FileSwapIconSignature {
  Element: SVGSVGElement;
}

export const FileSwapIcon: TOC<FileSwapIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 2.00003V4.58603L16.707 1.29303L15.293 2.70703L18.586 6.00003H16V8.00003H22V2.00003H20ZM8 18V16H2V22H4V19.414L7.293 22.707L8.707 21.293L5.414 18H8ZM12 9.00003H19C20.103 9.00003 21 9.89803 21 11V20C21 21.103 20.103 22 19 22H12C10.897 22 10 21.103 10 20V11C10 9.89803 10.897 9.00003 12 9.00003ZM12 20V11H19L19.001 20H12ZM12 4.00003H5V13H9V15H5C3.897 15 3 14.103 3 13V4.00003C3 2.89803 3.897 2.00003 5 2.00003H12C13.103 2.00003 14 2.89803 14 4.00003V8.00003H12V4.00003Z"/>
</svg>
</template>;